{"version":"0.5.0","sha":"b0d2609","branch":"develop","env":"dev","builtAt":"2026-08-23T16:34:41.833Z"}